import { gate } from 'hub-http/gates';
export const gates = {
  DATA_ENRICHMENT_DATA_TEST: gate('DataEnrichment:DataTest'),
  CREATE_NEW_LIST_IN_BULK_ACTIONS: gate('CRM:Segments:CreateNewListInBulkActions')
};